<h2 mat-dialog-title>Select Folder</h2>
<mat-dialog-content style="height: 250px;">
    <lex-folder-tree-view (clicked)="folderClick($event)"></lex-folder-tree-view>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
